import React from 'react'
import ContactedPage from './ContactedPage'

const WinPage = () => {
  return (
    <div>
      <ContactedPage />
    </div>
  )
}

export default WinPage
